import { IInventoryRepository } from '@/coreInfrastructureModule/interfaces/IInventoryRepository';
import { GetInventorySuccessResponseInfo, SortType } from '@/coreInfrastructureModule/axios/generated/inventoryManage';
import { FilterContentItem } from '@/corePagesModule/filterModal/filterModal';
import { FilterService } from '@/coreDomainsModule/services/filterService';
import { IError } from '@/coreInfrastructureModule/interfaces/IError';
import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { DateService } from '@/coreDomainsModule/services/dateService';

/**
 * 編集ページの集計情報取得UseCase
 */
export class BulkGetAggregateBusinessUseCase {
  private repository: IInventoryRepository;

  /**
   * コンストラクタ
   * @param repository - リポジトリ
   */
  constructor(repository: IInventoryRepository) {
    this.repository = repository;
  }

  // eslint-disable-next-line jsdoc/require-jsdoc
  public async execute(
    sortType: SortType,
    limit: number,
    offset: number,
    sortTarget: string,
    filterItems: FilterContentItem[]
  ): Promise<INetworkResult<GetInventorySuccessResponseInfo, IError>>;

  // eslint-disable-next-line jsdoc/require-jsdoc
  public async execute<T>(
    sortType: SortType,
    limit: number,
    offset: number,
    sortTarget: string,
    filterItems: FilterContentItem[],
    adapter: (response: GetInventorySuccessResponseInfo) => T
  ): Promise<INetworkResult<T, IError>>;

  /**
   * 集計情報(Master only)の取得
   * @param sortType - ソートタイプ
   * @param limit - 取得件数
   * @param offset - 取得開始位置
   * @param sortTarget - ソート対象
   * @param filterItems - フィルターの一覧
   * @param adapter - レスポンスをUIクラスに変更するアダプタ(指定しない場合レスポンス型がそのまま返る)
   * @returns - 集計情報
   */
  public async execute<T>(
    sortType: SortType,
    limit: number,
    offset: number,
    sortTarget: string,
    filterItems: FilterContentItem[],
    adapter?: (response: GetInventorySuccessResponseInfo) => T
  ): Promise<INetworkResult<GetInventorySuccessResponseInfo | T, IError>> {
    const [filterItem, filterInfoItem] = FilterService.convertFilterObjectWithInfo(filterItems);
    // この2つは使わないので適当に当日を入れとく
    const earlyPeriod = DateService.convertDateStrToDateWithHyphen(new Date());
    const latterPeriod = DateService.convertDateStrToDateWithHyphen(new Date());
    try {
      const response = await this.repository.get(
        sortType,
        limit,
        offset,
        earlyPeriod,
        latterPeriod,
        filterInfoItem,
        sortTarget,
        filterItem,
        ''
      );
      if (response.status.type === 'success') {
        const data = response.status.data.result;
        return {
          status: {
            type: 'success',
            data: adapter ? adapter(data) : data,
          },
        };
      } else {
        return {
          status: {
            type: 'error',
            error: response.status.error,
          },
        };
      }
    } catch (error) {
      console.error('error', error);
      return {
        status: {
          type: 'error',
          error: {
            statusCode: 500,
            code: 'unknown',
            message: '未知のエラーが発生しました',
          },
        },
      };
    }
  }
}
